import { render, staticRenderFns } from "./AdminRequests.vue?vue&type=template&id=42293507&"
import script from "./AdminRequests.vue?vue&type=script&lang=js&"
export * from "./AdminRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports